import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PublicGalleryImage {
  id: string;
  image_url: string;
  prompt: string;
  model: string;
  width: number;
  height: number;
  category: string;
  created_at: string;
  expires_at: string;
  likes_count: number;
}

export const usePublicGallery = (category?: string, limit = 50) => {
  return useQuery({
    queryKey: ["public-gallery", category, limit],
    queryFn: async () => {
      let query = supabase
        .from("public_gallery")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(limit);

      if (category && category !== "Tous" && category !== "general") {
        query = query.eq("category", category.toLowerCase());
      }

      const { data, error } = await query;

      if (error) throw error;
      return data as PublicGalleryImage[];
    },
  });
};

// Map database categories to display names
export const categoryDisplayNames: Record<string, string> = {
  portrait: "Portraits",
  landscape: "Paysages",
  abstract: "Abstrait",
  anime: "Anime",
  fantasy: "Fantasy",
  scifi: "Sci-Fi",
  food: "Cuisine",
  animal: "Animaux",
  architecture: "Architecture",
  art: "Art",
  general: "Autres",
};

// Get all unique categories from the data
export const getAllCategories = () => [
  "Tous",
  ...Object.values(categoryDisplayNames),
];
